<script setup lang="ts">
interface ButtonEntry {
  icon: string;
  click: (args?: any) => any;
  label?: string;
}

const emit = defineEmits(['click']);

defineProps<{
  entries: ButtonEntry[];
}>();
</script>

<template>
  <div class="button-group">
    <button
      class="button"
      type="button"
      v-for="(entry, index) in entries"
      :key="index"
      v-on:click="entry.click()"
    >
      <template v-if="entry.label">{{ entry.label }}</template>
      <df-icon v-if="entry.icon" :code="entry.icon" />
    </button>
  </div>
</template>

<style scoped>
.button-group {
  background-color: var(--color-cardbg);
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-md);
  width: 100%;
}

.button-group > *:last-child {
  border-top-right-radius: var(--radius-sm);
  border-bottom-right-radius: var(--radius-sm);
}

.button-group > *:first-child {
  border-top-left-radius: var(--radius-sm);
  border-bottom-left-radius: var(--radius-sm);
}

.button {
  background: none;
  border: none;
  padding: var(--gap-md);
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.8rem;

  &:hover {
    background-color: var(--color-hover);
  }
}
</style>
